<section class="detail-page flex flex-col font-display w-full">
  <div class="page-header">
    <div class="min-w-0 flex-1">
      <p class="text-xs font-medium text-slate-500 mb-1">
        {{ getPageLabel() }}
      </p>
      <h1 class="text-xl sm:text-2xl font-bold text-slate-900 leading-snug truncate">
        {{ reimburse?.title ?? "Detail approval reimbursement" }}
      </h1>
      <p class="text-sm text-slate-500 mt-1" *ngIf="reimburse?.creator">
        Diajukan oleh
        {{ reimburse.creator.firstName }} {{ reimburse.creator.lastName }}
      </p>
    </div>
    <span
      *ngIf="reimburse?.status"
      class="shrink-0"
      [ngClass]="getStatusClass(reimburse.status)"
    >
      {{ reimburse.status }}
    </span>
  </div>

  <div class="summary-grid" *ngIf="reimburse">
    <div class="summary-item">
      <span class="summary-item__label">Reference ID</span>
      <span class="summary-item__value">#{{ reimburse.refId ?? "-" }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-item__label">Amount</span>
      <span class="summary-item__value summary-item__value--amount">
        {{ reimburse.amount | currency : "IDR" : "symbol" : "1.0-0" }}
      </span>
    </div>
    <div class="summary-item">
      <span class="summary-item__label">Category</span>
      <span class="summary-item__value">{{
        reimburse.expanseCategory?.name ?? "-"
      }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-item__label">Transaction date</span>
      <span class="summary-item__value">
        <ng-container *ngIf="reimburse.created_at; else noDate">
          {{ reimburse.created_at | date : "d MMM yyyy" }},
          {{ reimburse.created_at | date : "HH:mm" }} WIB
        </ng-container>
        <ng-template #noDate>-</ng-template>
      </span>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div class="lg:col-span-2 flex flex-col gap-6">
      <div class="section-card">
        <div class="section-card__header">
          <span class="section-card__title">Detail pengajuan</span>
        </div>
        <div class="section-card__body">
          <div class="info-grid">
            <div class="info-field">
              <span class="info-field__label">Tag</span>
              <span *ngIf="reimburse?.tag?.name; else noTag" class="tag-chip">{{
                reimburse.tag.name
              }}</span>
              <ng-template #noTag>
                <span class="info-field__value">-</span>
              </ng-template>
            </div>
            <div class="info-field">
              <span class="info-field__label">Location</span>
              <span class="info-field__value">{{
                reimburse?.location ?? "-"
              }}</span>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Description</span>
              <div class="info-field__text-block">
                {{ reimburse?.description ?? "-" }}
              </div>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Latest approval note</span>
              <div class="info-field__text-block">
                {{ latestApproval ?? "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-card__header">
          <span class="section-card__title">Informasi rekening</span>
        </div>
        <div class="section-card__body">
          <div class="bank-grid">
            <div class="bank-item">
              <span class="bank-item__label">Bank</span>
              <span class="bank-item__value">{{
                reimburse?.creator?.bankName ?? "-"
              }}</span>
            </div>
            <div class="bank-item">
              <span class="bank-item__label">Atas nama</span>
              <span class="bank-item__value">{{
                reimburse?.creator?.bankAccountName ?? "-"
              }}</span>
            </div>
            <div class="bank-item">
              <span class="bank-item__label">No. rekening</span>
              <span class="bank-item__value">{{
                reimburse?.creator?.bankAccountNumber ?? "-"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-card__header">
          <span class="section-card__title">History approval</span>
          <span class="text-xs text-slate-500">{{ approvalList.length }} record</span>
        </div>
        <div class="section-card__body !p-0 sm:!p-0">
          <div class="table-wrapper !border-0 !rounded-none">
            <table
              mat-table
              [dataSource]="approvalList"
              class="mat-elevation-z0 font-display w-full"
            >
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let element">
                  <span class="font-medium text-slate-800">
                    {{ element.user?.firstName }} {{ element.user?.lastName }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="team">
                <th mat-header-cell *matHeaderCellDef>Team</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.user?.team?.name || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sequence">
                <th mat-header-cell *matHeaderCellDef>Seq</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <span
                    class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-xs font-bold text-slate-600"
                  >
                    {{ i + 1 }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.approve_at; else noApproveDate">
                    {{ element.approve_at | date : "d MMM yyyy" }},
                    {{ element.approve_at | date : "HH:mm" : "+0700" }} WIB
                  </ng-container>
                  <ng-template #noApproveDate>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span [ngClass]="getApprovalStatusClass(element.status)">
                    {{ getApprovalStatusLabel(element.status) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef>Notes</th>
                <td mat-cell *matCellDef="let element" class="notes-cell">
                  <span class="note-text">{{
                    element.approval_note || "-"
                  }}</span>
                </td>
              </ng-container>

              <ng-container stickyEnd matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button
                    (click)="detail(element, i + 1)"
                    class="table-action-btn table-action-btn--primary"
                    title="Detail"
                  >
                    <i class="fa-solid fa-eye text-xs"></i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                  <div class="empty-state">
                    <div class="empty-state__icon">
                      <i class="fa-solid fa-inbox"></i>
                    </div>
                    <span class="font-semibold text-slate-600"
                      >Belum ada riwayat approval</span
                    >
                    <span class="text-xs">Approval akan muncul setelah diproses</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <div class="section-card">
        <div class="section-card__header">
          <span class="section-card__title">Lampiran</span>
          <span class="text-xs text-slate-500" *ngIf="reimburse">
            {{ getFileItems(reimburse).length }} file
          </span>
        </div>
        <div class="section-card__body">
          <div
            class="attachment-list"
            *ngIf="reimburse && getFileItems(reimburse).length"
          >
            <button
              *ngFor="let fileItem of getFileItems(reimburse)"
              type="button"
              (click)="openFile(fileItem)"
              class="attachment-item"
            >
              <span class="attachment-item__name">
                <i class="fa-solid fa-file text-red-500 shrink-0"></i>
                <span class="truncate">{{
                  fileItem.fileName ?? "Attachment"
                }}</span>
              </span>
              <i class="fa-solid fa-eye text-slate-400 shrink-0 text-sm"></i>
            </button>
          </div>
          <div
            class="empty-state"
            *ngIf="!reimburse || !getFileItems(reimburse).length"
          >
            <div class="empty-state__icon">
              <i class="fa-solid fa-paperclip"></i>
            </div>
            <span>Tidak ada lampiran</span>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-card__header">
          <span class="section-card__title">Riwayat aktivitas</span>
        </div>
        <div class="section-card__body">
          <div class="timeline" *ngIf="reimburseLogs.length; else noLogs">
            <div
              class="timeline-item"
              *ngFor="let item of reimburseLogs; let i = index"
            >
              <div class="timeline-item__track">
                <button
                  (click)="openProfile(item.creator?.id)"
                  class="timeline-item__avatar"
                  [ngClass]="getLogAccentClass(item)"
                >
                  <img
                    [src]="item.creator?.imageUrl || 'profile.png'"
                    alt="Profile"
                  />
                </button>
                <div
                  class="timeline-item__line"
                  [ngClass]="getLogAccentClass(item)"
                  *ngIf="i != reimburseLogs.length - 1"
                ></div>
              </div>
              <div class="timeline-item__content">
                <button
                  (click)="openProfile(item?.creator?.id)"
                  class="timeline-item__name"
                >
                  {{ item.creator?.firstName }} {{ item.creator?.lastName }}
                </button>
                <p class="timeline-item__desc">{{ item.description }}</p>
                <span
                  class="timeline-item__time"
                  *ngIf="getLogTimestamp(item) as timestamp"
                >
                  {{ timestamp | date : "d MMM yyyy" }},
                  {{ timestamp | date : "HH:mm" : "+0700" }} WIB
                </span>
                <span
                  class="timeline-item__time timeline-item__time--pending"
                  *ngIf="!getLogTimestamp(item) && isWaitingLog(item)"
                >
                  Menunggu
                </span>
              </div>
            </div>
          </div>
          <ng-template #noLogs>
            <div class="empty-state">
              <div class="empty-state__icon">
                <i class="fa-solid fa-clock-rotate-left"></i>
              </div>
              <span>Belum ada aktivitas</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="action-bar" *ngIf="checkCanApprove()">
    <button (click)="approve()" class="action-btn action-btn--approve">
      <i class="fa-solid fa-check mr-2"></i>
      Approve
    </button>
    <button (click)="reject()" class="action-btn action-btn--reject">
      <i class="fa-solid fa-xmark mr-2"></i>
      Reject
    </button>
  </div>

  <div
    class="action-bar"
    *ngIf="
      reimburse &&
      reimburse.status == 'Rejected' &&
      reimburse.created_by == currentUser.id
    "
  >
    <button (click)="resubmit(reimburse.id)" class="action-btn action-btn--approve">
      <i class="fa-solid fa-rotate-right mr-2"></i>
      Resubmit
    </button>
    <button (click)="close()" class="action-btn action-btn--reject">
      <i class="fa-solid fa-ban mr-2"></i>
      Close transaction
    </button>
  </div>
</section>
